import { useConfig } from "@/providers/config/useConfig";
import type { TranslationKey } from "@/translations";
import { useTranslation } from "@/translations";

/**
 * Resolves contextual-help tooltip copy for dashboard metrics, gated behind the
 * `isDashboardContextualHelpAvailable` feature flag. Returns `undefined` when the
 * flag is off so the surrounding `Info`/tooltip affordance is skipped. Adding a
 * new explanation is a single `help("...")` call, no interaction changes needed.
 */
export function useMetricHelp(): (key: TranslationKey) => string | undefined {
  const isEnabled = useConfig("isDashboardContextualHelpAvailable");
  const { t } = useTranslation();

  return (key: TranslationKey) => (isEnabled ? t(key) : undefined);
}
